/* istanbul ignore file */
// Generated code for Big.Webservice.Controllers.LoggingController.
// Edit _ApiService.tst to change the generated output.
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ZorroApiClient } from '../zorro-api-client';

import { LogEvent } from '../models/log-event';

@Injectable()
export class LoggingApiService extends ZorroApiClient {

    constructor(
      private readonly httpClient: HttpClient
    ) {
        super();
    }


    public log(logEvent: LogEvent, spinnerMessage: string = null): Observable<void> {
        return this.httpClient.post<void>(`/api/log`, logEvent,
        {params: this.createOptions(null, spinnerMessage)}); // tslint:disable-line //NOSONAR
    }

}
